module.exports = __webpack_public_path__ + "img/signup-carousel-fourth@2x.c6baec61.png";